var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"time-answer__text"},[(_vm.timeAnswer)?_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t('youAnsweredIn', {
          msg: '<strong>' + _vm.getTimeCount(_vm.timeAnswer) +'</strong>',
          num: _vm.getTimeCount(_vm.timeLeft)
        })
      )}}):_vm._e(),_c('br'),_c('span',[_vm._v(_vm._s(_vm.$t("waitAndSeeHowYouDid")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }